import axios from './axios.config';

interface LoginCredentials {
    email: string;
    password: string;
    privacyConsent?: boolean;
}

interface LoginResponse {
    token: string;
    user: User;
}

export interface User {
    id: number;
    willowId: string;
    name: string;
    email: string;
    role: string;
    companyName: string;
    companyAddress: string;
    phoneNumber: string;
    yardName: string;
    yardLocation: string;
    isActive: boolean;
    createdAt: string;
    updatedAt: string;
    dot: string;
}

export interface ListUsersResponse {
    users: User[];
    total: number;
    page: number;
    limit: number;
}

export const userService = {
    login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
        try {
            const response = await axios.post<LoginResponse>('/login', credentials);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    changePassword: async (passwordData: { currentPassword: string; newPassword: string }): Promise<void> => {
        try {
            await axios.put('/change-password', passwordData);
        } catch (error) {
            throw error;
        }
    }
};
